import React from 'react';

import withAppState from '../mobx/withAppState'

import PayByCard from './PayByCard';
import PayByVault from './PayByVault';
import PayByPaypal from './PayByPaypal';
import PayByApplePay from './PayByApplePay';
import PayByGooglePay from './PayByGooglePay';

import Loading from './Loading';

class Pay extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      canUseApplePay: false,
      clientToken: null,
      googlePayEnabled: true,
      paypalEnabled: true,
      googleEnvironment: null,
      googleMerchantId: null,
      paypalEnvironment: null,
      loading: false
    };
    this.optInCheckbox = React.createRef();
    this.props.startedLoadingPaymentForm();
  }

  componentWillUnmount() {
    this.props.submitPaymentCancel();
  }

  async componentDidMount() {
    const ApplePaySession = window.ApplePaySession;
    if (
      !!ApplePaySession &&
      ApplePaySession.supportsVersion(3) &&
      ApplePaySession.canMakePayments()
    ) {
      this.setState({ canUseApplePay: true });
    }

    var vaultId = '';
    if (!!this.props.customer && !!this.props.customer.vaultId)
      vaultId = this.props.customer.vaultId;

    const { id: restaurantId } = this.props.restaurant;
    console.log("restaurant Id = " + restaurantId + " vault id = " + vaultId)
    const response = await fetch(`api/Braintree/GetClientToken/${restaurantId}/${vaultId}`);
    let data;
    try {
      data = await response.json();
      const { clientToken, paypalEnabled, googlePayEnabled, googleEnvironment, googleMerchantId, paypalEnvironment } = data;

      this.setState({
        clientToken: clientToken,
        paypalEnabled: paypalEnabled,
        googlePayEnabled: googlePayEnabled,
        googleEnvironment: googleEnvironment,
        googleMerchantId: googleMerchantId,
        paypalEnvironment: paypalEnvironment
      });
    } catch (err) {
      this.props.handleNoClientToken();
    }
  }

  componentDidUpdate() {
    this.updateMainCTAText();
  }

  updateMainCTAText() {
    let mainCTAText = `Pay ${this.props.getCurrency().symbol + (
      parseFloat(this.props.billTotal) +
      parseFloat(this.props.gratuityTotal || 0)
    ).toFixed(2)}`;
    this.props.setMainCTAText(mainCTAText);
  }

  clickedCheckoutOptIn() {
    let checked = this.optInCheckbox.current.checked;
    this.props.setOptingInAtCheckout(checked);
  }

  clickedCheckoutOptOut() {
    let checked = this.optInCheckbox.current.checked;
    this.props.setOptedOutAtCheckout(checked)
  }

  render() {

    if (!!this.state.clientToken) {
      const paymentFailReason = !!this.props.paymentFailReason
        ? this.props.paymentFailReason
        : 'Payment failed, please try again.';

      return (
        <div className="pay-by-container">
          {this.props.paymentLoadingAnimation === true && (
            <div className="loading-container">
              <Loading />
            </div>
          )}
          {this.props.paymentFailed === true && (
            <p className="payment-failure-message">{paymentFailReason}</p>
          )}

          {(this.state.canUseApplePay || this.state.googlePayEnabled || this.state.paypalEnabled) ? (
            <div
              className={`express-checkout ${this.props.submittingPayment === true ? 'hidden' : ''
                }`}
            >
              <h3
                className={`title ${this.props.submittingPayment === true ? 'hidden' : ''
                  }`}
              >
                EXPRESS CHECKOUT
              </h3>
              {this.state.paypalEnabled && (
                <PayByPaypal
                  environment={this.state.paypalEnvironment}
                  clientToken={this.state.clientToken}
                  {...this.props}
                />)}

              {this.state.canUseApplePay && (
                <PayByApplePay clientToken={this.state.clientToken} {...this.props} />
              )}
              {this.state.googlePayEnabled &&
                <PayByGooglePay
                  environment={this.state.googleEnvironment}
                  merchantId={this.state.googleMerchantId}
                  clientToken={this.state.clientToken}
                  {...this.props}
                />
              }
              {!!this.props.customer &&
                this.props.customer.vaultId && (
                  <PayByVault clientToken={this.state.clientToken} {...this.props} />
                )}
            </div>
          ) : null}

          <>
            <h3
              style={
                this.props.submittingPayment === true
                  ? { display: 'none' }
                  : {}
              }
              className="title pay-by-card-title"
            >
              Pay by card
            </h3>
            <PayByCard clientToken={this.state.clientToken} {...this.props} />
          </>

          {this.props.submittingPayment === false &&
            ((!!this.props.customer && !!this.props.customer.id) ===
              false ||
              (!!this.props.customer &&
                !!this.props.customer.emailOptIn) === false) ? (
            <div className="checkbox-container">
              <div className="checkbox-wrapper">
                {!this.props.getApplySoftOptIn() &&
                  <input
                    type="checkbox"
                    id="opt-in-checkbox"
                    ref={this.optInCheckbox}
                    defaultChecked={this.props.optingInAtCheckout}
                    onChange={() => this.clickedCheckoutOptIn()}
                  />
                }
                {this.props.getApplySoftOptIn() &&
                  <input
                    type="checkbox"
                    id="opt-in-checkbox"
                    ref={this.optInCheckbox}
                    defaultChecked={this.props.optedOutAtCheckout}
                    onChange={() => this.clickedCheckoutOptOut()}
                  />
                }
              </div>
              <label className="optin-label" htmlFor="opt-in-checkbox">
                {!this.props.getApplySoftOptIn() &&
                  <p>Tick here to receive fantastic offers & news from {this.props.getCompanyName()} straight to your email!</p>
                }
                {this.props.getApplySoftOptIn() &&
                  <p>By making your payment, {this.props.getCompanyName()} will send you news and fantastic offers via email. Please tick the box if you do not want to receive this.</p>
                }
                <p>
                  {(this.props.getCompanyName() === 'Milano') ? 'Must be 16 or over | ' : ''}<a
                    className="link"
                    onClick={() => this.props.termAndConditionsModal()}
                  >
                    Terms & Conditions
                  </a>{' '}
                  and{' '}
                  <a
                    className="link"
                    onClick={() => this.props.privacyPolicyModal()}
                  >
                    Privacy Policy
                  </a>
                </p>
              </label>
            </div>
          ) : null}
        </div>
      );
    } else {
      return (
        <div className="loading-container">
          <Loading />
        </div>
      );
    }
  }
}

export default withAppState(Pay,
  {
    mobXProps: ({
      customer,
      socialCustomer,
      billTotal,
      gratuityTotal,
      paymentFailReason,
      paymentLoadingAnimation,
      paymentFailed,
      submittingPayment,
      grandTotal,
      restaurant,
    }) => ({
      customer,
      socialCustomer,
      billTotal,
      gratuityTotal,
      paymentFailReason,
      paymentLoadingAnimation,
      paymentFailed,
      submittingPayment,
      grandTotal,
      restaurant,
    }),
    mobXActions: ({
      startedLoadingPaymentForm,
      submitPayment,
      submitPaymentCancel,
      submitPaymentFail,
      setErrorModalMessage,
      setMainCTAText,
      setMainCTA,
      setOptingInAtCheckout,
      setOptedOutAtCheckout,
      termAndConditionsModal,
      privacyPolicyModal,
      generatePaymentBody,
      storeCustomerEmail,
      paymentSuccessful,
      storeVaultId,
      pausePaymentLoadingAnimation,
      unpausePaymentLoadingAnimation,
      finishedPaymentLoadingAnimation,
      setMainModalCTA,
      setupMainModal,
      enableMainModal,
      getCurrency,
      getCompanyName,
      getReturnHref,
      getApplySoftOptIn
    }) => ({
      startedLoadingPaymentForm,
      submitPayment,
      submitPaymentCancel,
      submitPaymentFail,
      setErrorModalMessage,
      setMainCTAText,
      setMainCTA,
      setOptingInAtCheckout,
      setOptedOutAtCheckout,
      termAndConditionsModal,
      privacyPolicyModal,
      generatePaymentBody,
      storeCustomerEmail,
      paymentSuccessful,
      storeVaultId,
      pausePaymentLoadingAnimation,
      unpausePaymentLoadingAnimation,
      finishedPaymentLoadingAnimation,
      setMainModalCTA,
      setupMainModal,
      enableMainModal,
      getCurrency,
      getCompanyName,
      getReturnHref,
      getApplySoftOptIn
    })
  }
);
